import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { fetchMe } from 'redux/users/actions';
import { patchUser, clearPatchUser } from 'redux/settings/actions';

import onClickOutside from 'react-onclickoutside';

import UsernamePopup from 'components/dashboard/settings-content/UsernamePopup';

import { PUBLIC_SITE_URL } from 'utils/restapi';

import './ChangeUsername.css';

const ENTER_KEY = 13;

class ChangeUsername extends Component {
  static propTypes = {
    fetchMe: PropTypes.func.isRequired,
    patchUser: PropTypes.func.isRequired,
    clearPatchUser: PropTypes.func.isRequired,
    me: PropTypes.object,
    patchUserSuccess: PropTypes.object,
    patchUserError: PropTypes.object,
  };

  static defaultProps = {
    me: null,
    patchUserSuccess: null,
    patchUserError: null,
  };

  state = {
    initialValue: '',
    currentValue: '',
    copyButtonActive: false,
    copyUrl: false,
    copyUrlShort: false,
    editBtnActive: true,
  };

  componentDidMount() {
    document.addEventListener('keyup', this.onEnterClick);

    if (this.props.me) {
      this.setState({
        initialValue: this.props.me.username,
        currentValue: this.props.me.username,
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.me &&
      prevProps.me.username &&
      this.props.patchUserSuccess &&
      this.props.patchUserSuccess.username &&
      prevProps.me.username !== this.props.patchUserSuccess.username
     ) {
      this.props.fetchMe();
      this.props.clearPatchUser();
    }
  }

  componentWillUnmount() {
    document.removeEventListener('keyup', this.onEnterClick);
  }

  handleClickOutside = () => {
    this.changeUserName();
    this.setState({
      copyButtonActive: false,
      editBtnActive: true,
    });
  };

  onEnterClick = (event) => {
    if (event.keyCode === ENTER_KEY) {
      this.changeUserName();
    }
  };

  changeUserName = () => {
    const { initialValue, currentValue } = this.state;

    if (currentValue !== initialValue) {
      this.setState({ initialValue: currentValue});
      const form = new FormData();
      form.append('username', currentValue);
      this.props.patchUser(form);
    }
  };

  toggleCopyButton = () => {
    this.setState({
      copyButtonActive: !this.state.copyButtonActive,
      editBtnActive: !this.state.editBtnActive,
    });
  };

  render() {
    const { patchUserError, me } = this.props;
    const { currentValue, copyUrl, copyUrlShort, copyButtonActive, editBtnActive } = this.state;
    const siteUrl = `${PUBLIC_SITE_URL.replace(/^https?\:\/\//i, "")}/`;

    return (
      <div className="change-username__component">
        {/* Input Wrapper */}
        <div className="input-wrapper">
          <div className="prefix">
            <div className="desktop">{siteUrl}</div>
            {/* <div className="mobile">.../</div> */}
          </div>
          <a
            className="link"
            href={me.url}
            target="_blank"
            rel="noreferrer noopener"
          >
            {me.username}
          </a>

          <UsernamePopup me={me} />

        </div>
      </div>
    );
  }
}

const mapStateToProps = state => (
  {
    me: state.usersReducer.me,
    patchUserSuccess: state.settingsReducer.patchUserSuccess,
    patchUserError: state.settingsReducer.patchUserError,
  }
);

export default connect(
  mapStateToProps,
  {
    fetchMe,
    patchUser,
    clearPatchUser,
  },
)(onClickOutside(ChangeUsername));
